import { JobIssueVendor, SyncableStatus } from "../../../core/database/db";
import { UserVendorContactDTO } from "./UserVendorContactDTO";

export const UNKNOWN_VENDOR: VendorDTO = {
  id: 0,
  name: "Unknown Vendor",
  doingBusinessAs: "",
  userVendorContacts: []
};

export const SELF_ASSIGNED_VENDOR: VendorDTO = {
  id: -1,
  name: "Assigned To Me",
  doingBusinessAs: "",
  userVendorContacts: []
};

export const SELF_ASSIGNED_VENDOR_ASSIGNMENT: JobIssueVendor = {
  issueVendorIdentifier: "00000000-0000-0000-0000-000000000000",
  externalVendorId: SELF_ASSIGNED_VENDOR.id,
  issueIdentifier: "",
  isSent: false,
  updatedAt: new Date(),
  createdAt: new Date(),
  syncStatus: SyncableStatus.Completed
};

export const NO_VENDOR_ASSIGNED_IDENTIFIER = "00000000-0000-0000-0000-000000000001";

/** Label for the pinned self-assignment row at the top of a vendor select. */
export const ASSIGN_TO_ME_OPTION_LABEL = "Assign to Me";

/** Vendor select options with the CM's own "Assign to Me" entry pinned above the trade partners. */
export function withAssignToMeOption(vendors: VendorDTO[]): VendorDTO[] {
  return [SELF_ASSIGNED_VENDOR, ...vendors.filter(vendor => vendor.id !== SELF_ASSIGNED_VENDOR.id)];
}

export interface VendorDTO {
  id: number;
  name: string;
  doingBusinessAs: string;
  userVendorContacts: UserVendorContactDTO[];
}